import { DOCUMENT_SIDE, PASSPORT_PAGES_ORDER } from './FileUpload.constants';

export const getSupportedFormatsString = (formats) => {
  return formats
    .map((format) => format.split('/')[1]?.toUpperCase() || format.split('/')[0]?.toUpperCase())
    .join(', ');
};

export const pagesCompare = (a, b) => {
  if (!a.classification || !a.classification.type) {
    return 1;
  }

  if (!b.classification || !b.classification.type) {
    return -1;
  }

  if (PASSPORT_PAGES_ORDER.indexOf(a.classification.type) === -1) {
    return -1;
  }

  if (PASSPORT_PAGES_ORDER.indexOf(b.classification.type) === -1) {
    return 0;
  }

  return (
    PASSPORT_PAGES_ORDER.indexOf(a.classification.type) -
    PASSPORT_PAGES_ORDER.indexOf(b.classification.type)
  );
};

export const driverLicenseCompare = (a, b) => {
  if (!a.classification || !a.classification.type) {
    return 1;
  }

  if (!b.classification || !b.classification.type) {
    return -1;
  }

  if (b.classification.type.includes(DOCUMENT_SIDE.FRONT)) {
    return 1;
  }

  if (b.classification.type.includes(DOCUMENT_SIDE.BACK)) {
    return -1;
  }

  return 0;
};

export const prepareFormData = (validFiles, currentPersonId) => {
  if (!validFiles?.length) {
    throw new Error('No valid files provided');
  }

  if (!currentPersonId) {
    throw new Error('No currentPersonId provided');
  }

  const formData = new FormData();
  validFiles.forEach((file) => formData.append('file[]', file));

  const params = {
    entryName: 'customer',
    entryId: currentPersonId,
  };

  formData.append(
    'payload',
    new Blob([JSON.stringify(params)], { type: 'application/json' }),
    'payload.json'
  );

  return formData;
};
